
export default function CallToAction() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-[#0B1F3A] py-20 sm:py-28 lg:py-36 relative overflow-hidden">
      <div className="absolute top-10 right-20 w-32 h-32 bg-[#1a3354] rounded-3xl opacity-30 rotate-12 hidden sm:block"></div>
      <div className="absolute bottom-20 right-40 w-24 h-24 bg-[#1a3354] rounded-2xl opacity-20 -rotate-6 hidden sm:block"></div>
      <div className="absolute top-1/2 right-10 w-40 h-40 bg-[#1a3354] rounded-full opacity-15 hidden sm:block"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-8 text-center relative z-10">
        <h2
          className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight"
          style={{ fontFamily: 'Montserrat, sans-serif', lineHeight: '1.2' }}
        >
          Ready to Upgrade Your Home?
        </h2>
        <p
          className="text-white/60 text-base sm:text-lg md:text-xl mb-8 sm:mb-10 leading-relaxed"
          style={{ fontFamily: 'Open Sans, sans-serif' }}
        >
          Contact Premier Renovations today to schedule your free estimate and transform your
          space.
        </p>
        <button
          onClick={scrollToContact}
          className="bg-[#2D6CDF] text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg font-semibold hover:bg-[#2558b8] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
          style={{ fontFamily: 'Open Sans, sans-serif' }}
        >
          Get Free Estimate
        </button>
      </div>
    </section>
  );
}
